// Import utilities
import { getDOMElements } from '@builder-legacy/common/utilities';

// Load class that creates the grid with integrations
import ItemCreatorIntegrations from '@builder-legacy/item/integrations-grid';

/**
 * Adds the initial "Add action" button (when there aren't actions)
 */
export default class ItemInitialAction {
	/**
	 * Renders the item
	 * 
	 * @return {undefined}
	 */
	constructor() {
		// Create template
		const $template = document.createElement( 'div' );
		$template.classList.add( 'uap-item', 'uap-item--actions-initial' );

		// Add content
		$template.insertAdjacentHTML( 'beforeEnd', `
			<div class="uap-item-inner">
				<div class="uap-item-sidebar">
					<div class="uap-item-icon"></div>
				</div>
				<div class="uap-item-main">
					<uo-button
						color="secondary"
						size="small"
						class="uap-item-main-initial-action-button uap-spacing-right uap-spacing-right--xsmall"
					>
						${ UncannyAutomator._core.i18n.action.add }
					</uo-button>

					${ 
						UncannyAutomator._site.automator.has_pro ? 
						`
							<uo-button-dropdown class="add-action-btn">
								<uo-button 
									slot="target" 
									color="secondary"
									size="small"
								>
									${ UncannyAutomator._core.i18n.add } <uo-icon id="angle-down"></uo-icon>
								</uo-button>

								<ua-builder-conditions-add-button 
									size="small"
									color="transparent"
								>
									${ UncannyAutomator._core.i18n.conditions.filter }
								</ua-builder-conditions-add-button>

								<uap-builder-loop-add-user-loop
									size="small"
									color="transparent"
								></uap-builder-loop-add-user-loop>

								${ 
									_uo.utility.versionCompare( 
										UncannyAutomator._site.automator.version_pro, 
										'5.3', 
										'>=' 
									) ? 
									`<uap-builder-loop-add-post-loop
										size="small"
										color="transparent"
									></uap-builder-loop-add-post-loop>` : ''
								}

							</uo-button-dropdown>
						` : 
						'' 
					}
				</div>
			</div>
		` );

		// Add to the metabox
		const $metabox = getDOMElements( 'metabox', {
			type: 'action',
		} ).get(0);

		$metabox.appendChild( $template );

		// Add event listener to the button
		$template.querySelector( '.uap-item-main-initial-action-button' ).addEventListener( 'click', () => {
			// Show the integrations grid
			new ItemCreatorIntegrations( 'action' );
		} );
	}
}
